import { render } from "./Readme.vue?vue&type=template&id=c7b97892&scoped=true"
import script from "./Readme.vue?vue&type=script&lang=js"
export * from "./Readme.vue?vue&type=script&lang=js"

import "./Readme.vue?vue&type=style&index=0&id=c7b97892&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b97892"]])

export default __exports__